<nav class="sidebar main-font" [ngClass]="{ monitoraggio: checkMonitoraggio }">
  <header>
    <div
      class="bar-title d-flex align-items-center justify-content-between"
      *ngIf="!checkMonitoraggio">
      <img
        [src]="logo"
        alt="logo"
        class="logo img-fluid"
        routerLink="/secure/dashboard/bacheca" />
      <mat-icon
        *ngIf="isAdmin && !isSidenavClosed"
        class="btn-edit"
        (click)="functionShowToggleSection()"
        (keydown)="functionShowToggleSection()"
        [nz-tooltip]="
          showToggleSection ? 'Termina modifiche' : 'Modifica visibilità'
        "
        >{{ showToggleSection ? 'check' : 'edit' }}</mat-icon
      >
    </div>
    <div class="bar-title" *ngIf="checkMonitoraggio">
      <img
        [src]="logoMonitoraggio"
        class="logo-monitoraggio img-fluid"
        routerLink="/secure/dashboard/monitoraggio"
        alt="Logo Monitoraggio" />
    </div>
    <span>
      <mat-icon class="toggle left-oriented" (click)="toggle()" onkeydown="">
        arrow_forward_ios
      </mat-icon>
    </span>
  </header>

  <div class="menu-bar">
    <div class="h-75 d-flex justify-content-between">
      <ul class="menu-items h-100">
        <li class="nav-link" *ngIf="!checkMonitoraggio">
          <a
            class="hover-pointer"
            routerLink="bacheca"
            routerLinkActive="active-link">
            <span class="icon material-symbols-outlined">
              <mat-icon [matTooltip]="isSidenavClosed ? 'Dashboard' : ''"
                >dashboard</mat-icon
              >
              <mat-badge
                *ngIf="isSidenavClosed"
                [matBadge]="notification"
                matBadgeOverlap="false"
                matBadgeSize="small"
                [matBadgeHidden]="notification == 0"
                class="badge px-0"></mat-badge>
            </span>
            <span
              [matBadge]="notification"
              matBadgeOverlap="false"
              matBadgeSize="small"
              [matBadgeHidden]="notification == 0"
              class="badge ps-1 text">
              BACHECA
            </span>
          </a>
        </li>

        <li
          class="nav-link"
          *ngIf="!checkMonitoraggio && canAccessSection('competenze')">
          <a
            class="hover-pointer"
            routerLink="calendario"
            routerLinkActive="active-link">
            <span class="icon material-symbols-outlined">
              <mat-icon [matTooltip]="isSidenavClosed ? 'CALENDARIO' : ''"
                >article</mat-icon
              >
            </span>
            <span class="text ps-1">CALENDARIO</span>
          </a>
        </li>

        <li class="nav-link" *ngIf="!checkMonitoraggio">
          <a
            class="hover-pointer"
            routerLink="competenze"
            routerLinkActive="active-link">
            <span class="icon material-symbols-outlined">
              <mat-icon
                [ngClass]="isSectionActive('competenze') ? '' : 'icon-purple'"
                [matTooltip]="isSidenavClosed ? 'Competenze' : ''"
                >settings</mat-icon
              >
            </span>
            <span
              class="text ps-1"
              [ngClass]="isSectionActive('competenze') ? '' : 'text-purple'"
              >COMPETENZE</span
            >
          </a>
          <nz-switch
            *ngIf="showToggleSection"
            class="text-end"
            nzSize="small"
            [ngModel]="isSectionActive('competenze')"
            (ngModelChange)="
              setAccessSection('competenze', $event)
            "></nz-switch>
        </li>

        <li
          class="nav-link"
          *ngIf="!checkMonitoraggio && canAccessSection('consapevolezza')">
          <a
            class="hover-pointer"
            routerLink="consapevolezza"
            routerLinkActive="active-link">
            <span class="icon material-symbols-outlined">
              <mat-icon
                [ngClass]="
                  isSectionActive('consapevolezza') ? '' : 'icon-purple'
                "
                [matTooltip]="isSidenavClosed ? 'Consapevolezza' : ''"
                >receipt</mat-icon
              >
            </span>
            <span
              class="text ps-1"
              [ngClass]="isSectionActive('consapevolezza') ? '' : 'text-purple'"
              >CONSAPEVOLEZZA</span
            >
          </a>
          <nz-switch
            *ngIf="showToggleSection"
            class="text-end"
            nzSize="small"
            [ngModel]="isSectionActive('consapevolezza')"
            (ngModelChange)="
              setAccessSection('consapevolezza', $event)
            "></nz-switch>
        </li>

        <li
          class="nav-link"
          *ngIf="!checkMonitoraggio && canAccessSection('condivisione')">
          <a
            class="hover-pointer"
            routerLink="condivisione"
            routerLinkActive="active-link">
            <span class="icon material-symbols-outlined">
              <mat-icon
                [ngClass]="isSectionActive('condivisione') ? '' : 'icon-purple'"
                [matTooltip]="isSidenavClosed ? 'Condivisione' : ''"
                >share</mat-icon
              >
            </span>
            <span
              class="text ps-1"
              [ngClass]="isSectionActive('condivisione') ? '' : 'text-purple'"
              >CONDIVISIONE</span
            >
          </a>
          <nz-switch
            *ngIf="showToggleSection"
            class="text-end"
            nzSize="small"
            [ngModel]="isSectionActive('condivisione')"
            (ngModelChange)="
              setAccessSection('condivisione', $event)
            "></nz-switch>
        </li>

        <li
          class="nav-link"
          *ngIf="
            !checkMonitoraggio && canAccessSection('percorso di crescita')
          ">
          <a
            class="hover-pointer"
            routerLink="percorso-di-crescita"
            routerLinkActive="active-link">
            <span class="icon material-symbols-outlined">
              <mat-icon
                [ngClass]="
                  isSectionActive('percorso di crescita') ? '' : 'icon-purple'
                "
                *ngIf="!isSidenavClosed"
                >timeline</mat-icon
              >
              <mat-icon
                [ngClass]="
                  isSectionActive('percorso di crescita') ? '' : 'icon-purple'
                "
                *ngIf="isSidenavClosed"
                matTooltip="Percorso di crescita"
                >timeline</mat-icon
              >
            </span>
            <span
              class="text ps-1"
              [ngClass]="
                isSectionActive('percorso di crescita') ? '' : 'text-purple'
              "
              >PERCORSO DI CRESCITA</span
            >
          </a>
          <nz-switch
            *ngIf="showToggleSection"
            class="text-end"
            nzSize="small"
            [ngModel]="isSectionActive('percorso di crescita')"
            (ngModelChange)="
              setAccessSection('percorso di crescita', $event)
            "></nz-switch>
        </li>

        <li
          class="nav-link"
          *ngIf="!checkMonitoraggio && canAccessSection('review')">
          <a
            class="hover-pointer"
            routerLink="review"
            routerLinkActive="active-link">
            <span class="icon material-symbols-outlined">
              <mat-icon
                [ngClass]="isSectionActive('review') ? '' : 'icon-purple'"
                [matTooltip]="isSidenavClosed ? 'Review' : ''"
                >rate_review</mat-icon
              >
            </span>
            <span
              class="text ps-1"
              [ngClass]="isSectionActive('review') ? '' : 'text-purple'"
              >REVIEW</span
            >
          </a>
          <nz-switch
            *ngIf="showToggleSection"
            class="text-end"
            nzSize="small"
            [ngModel]="isSectionActive('review')"
            (ngModelChange)="setAccessSection('review', $event)"></nz-switch>
        </li>

        <li
          class="nav-link"
          *ngIf="!checkMonitoraggio && canAccessSection('sbi')">
          <a
            class="hover-pointer"
            routerLink="sbi"
            routerLinkActive="active-link">
            <div class="sidebar-icon">
              <i
                [ngClass]="
                  isSectionActive('sbi') ? 'icon-sbi' : 'icon-purple-sbi'
                "></i>
            </div>
            <span
              class="text ps-1"
              [ngClass]="isSectionActive('sbi') ? '' : 'text-purple'"
              >SBI</span
            >
          </a>
          <nz-switch
            *ngIf="showToggleSection"
            class="text-end"
            nzSize="small"
            [ngModel]="isSectionActive('sbi')"
            (ngModelChange)="setAccessSection('sbi', $event)"></nz-switch>
        </li>

        <li
          class="nav-link"
          *ngIf="!checkMonitoraggio && canAccessSection('i miei team')">
          <a
            class="hover-pointer"
            routerLink="i-miei-team"
            routerLinkActive="active-link">
            <span class="icon material-symbols-outlined">
              <mat-icon
                [ngClass]="isSectionActive('i miei team') ? '' : 'icon-purple'"
                [matTooltip]="isSidenavClosed ? 'I miei team' : ''"
                >diversity_3</mat-icon
              >
            </span>
            <span
              class="text ps-1"
              [ngClass]="isSectionActive('i miei team') ? '' : 'text-purple'"
              >I MIEI TEAM</span
            >
          </a>
          <nz-switch
            *ngIf="showToggleSection"
            class="text-end"
            nzSize="small"
            [ngModel]="isSectionActive('i miei team')"
            (ngModelChange)="
              setAccessSection('i miei team', $event)
            "></nz-switch>
        </li>

        <li
          class="nav-link"
          *ngIf="!checkMonitoraggio && canAccessSection('sondaggi')">
          <a
            class="hover-pointer"
            routerLink="sondaggi"
            routerLinkActive="active-link">
            <span class="icon material-symbols-outlined">
              <mat-icon
                [ngClass]="isSectionActive('sondaggi') ? '' : 'icon-purple'"
                [matTooltip]="isSidenavClosed ? 'Sondaggi' : ''"
                >article</mat-icon
              >
            </span>
            <span
              class="text ps-1"
              [ngClass]="isSectionActive('sondaggi') ? '' : 'text-purple'"
              >SONDAGGI</span
            >
          </a>
          <nz-switch
            *ngIf="showToggleSection"
            class="text-end"
            nzSize="small"
            [ngModel]="isSectionActive('sondaggi')"
            (ngModelChange)="setAccessSection('sondaggi', $event)"></nz-switch>
        </li>

        <li
          class="nav-link"
          *ngIf="!checkMonitoraggio && canAccessSection('time sheet')">
          <a
            class="hover-pointer"
            routerLink="time-sheet"
            routerLinkActive="active-link">
            <div class="sidebar-icon">
              <img
                [src]="
                  isSectionActive('time sheet')
                    ? 'assets/images/Shared/overview.svg'
                    : 'assets/images/Shared/overview_purple.svg'
                "
                alt="timesheet"
                height="24px"
                width="24px" />
            </div>
            <span
              class="text ps-1"
              [ngClass]="isSectionActive('time sheet') ? '' : 'text-purple'"
              >TIME SHEET</span
            >
          </a>
          <nz-switch
            *ngIf="showToggleSection"
            class="text-end"
            nzSize="small"
            [ngModel]="isSectionActive('time sheet')"
            (ngModelChange)="
              setAccessSection('time sheet', $event)
            "></nz-switch>
        </li>

        <li
          class="nav-link"
          *ngIf="!checkMonitoraggio && canAccessSection('time sheet')">
          <a
            class="hover-pointer"
            routerLink="time-sheet-2"
            routerLinkActive="active-link">
            <div class="sidebar-icon">
              <img
                [src]="
                  isSectionActive('time sheet')
                    ? 'assets/images/Shared/overview.svg'
                    : 'assets/images/Shared/overview_purple.svg'
                "
                alt="timesheet"
                height="24px"
                width="24px" />
            </div>
            <span
              class="text ps-1"
              [ngClass]="isSectionActive('time sheet') ? '' : 'text-purple'"
              >TIME SHEET 2</span
            >
          </a>
          <nz-switch
            *ngIf="showToggleSection"
            class="text-end"
            nzSize="small"
            [ngModel]="isSectionActive('time sheet')"
            (ngModelChange)="
              setAccessSection('time sheet', $event)
            "></nz-switch>
        </li>

        <li
          class="nav-link"
          *ngIf="!checkMonitoraggio && canAccessSection('wiki')">
          <a
            class="hover-pointer"
            routerLink="wiki"
            routerLinkActive="active-link">
            <span class="icon material-symbols-outlined">
              <mat-icon
                [ngClass]="isSectionActive('wiki') ? '' : 'icon-purple'"
                [matTooltip]="isSidenavClosed ? 'Wiki' : ''"
                >language</mat-icon
              >
            </span>
            <span
              class="text ps-1"
              [ngClass]="isSectionActive('wiki') ? '' : 'text-purple'"
              >WIKI</span
            >
          </a>
          <nz-switch
            *ngIf="showToggleSection"
            class="text-end"
            nzSize="small"
            [ngModel]="isSectionActive('wiki')"
            (ngModelChange)="setAccessSection('wiki', $event)"></nz-switch>
        </li>

        <li
          class="nav-link"
          *ngIf="!checkMonitoraggio && canAccessSection('feedback')">
          <a
            class="hover-pointer"
            routerLink="feedback"
            routerLinkActive="active-link">
            <span class="icon material-symbols-outlined">
              <mat-icon
                [ngClass]="isSectionActive('feedback') ? '' : 'icon-purple'"
                [matTooltip]="isSidenavClosed ? 'Feedback' : ''"
                >feedback</mat-icon
              >
            </span>
            <span
              class="text ps-1"
              [ngClass]="isSectionActive('feedback') ? '' : 'text-purple'"
              >FEEDBACK</span
            >
          </a>
          <nz-switch
            *ngIf="showToggleSection"
            class="text-end"
            nzSize="small"
            [ngModel]="isSectionActive('feedback')"
            (ngModelChange)="setAccessSection('feedback', $event)"></nz-switch>
        </li>

        <div
          *ngIf="
            !checkMonitoraggio && canAccessSection('monitoraggio') && isAdmin
          ">
          <li class="nav-link">
            <a
              class="hover-pointer"
              routerLink="monitoraggio"
              routerLinkActive="active-link">
              <span class="icon material-symbols-outlined">
                <mat-icon
                  [ngClass]="
                    isSectionActive('monitoraggio') ? '' : 'icon-purple'
                  "
                  [matTooltip]="isSidenavClosed ? 'Monitoraggio' : ''"
                  >bar_chart</mat-icon
                >
              </span>
              <span
                class="text ps-1"
                [ngClass]="isSectionActive('monitoraggio') ? '' : 'icon-purple'"
                >MONITORAGGIO</span
              >
            </a>
            <nz-switch
              *ngIf="showToggleSection"
              class="text-end"
              nzSize="small"
              [ngModel]="isSectionActive('monitoraggio')"
              (ngModelChange)="
                setAccessSection('monitoraggio', $event)
              "></nz-switch>
          </li>
        </div>
        <li
          class="nav-link"
          *ngIf="
            (isAdmin || role == 'project_manager') &&
            !checkMonitoraggio &&
            canAccessSection('impostazioni')
          ">
          <a
            class="hover-pointer"
            routerLink="impostazioni-admin"
            routerLinkActive="active-link">
            <span class="icon material-symbols-outlined">
              <mat-icon
                [ngClass]="isSectionActive('impostazioni') ? '' : 'icon-purple'"
                [matTooltip]="isSidenavClosed ? 'Impostazioni' : ''"
                >admin_panel_settings</mat-icon
              >
              <mat-badge
                *ngIf="isSidenavClosed"
                [matBadge]="hobbyNotification"
                matBadgeOverlap="false"
                matBadgeSize="small"
                [matBadgeHidden]="hobbyNotification == 0"
                class="badge px-0">
              </mat-badge>
            </span>
            <span
              [matBadge]="hobbyNotification"
              matBadgeOverlap="false"
              matBadgeSize="small"
              [matBadgeHidden]="hobbyNotification == 0"
              class="badge ps-1 text"
              [ngClass]="isSectionActive('impostazioni') ? '' : 'text-purple'"
              >IMPOSTAZIONI</span
            >
          </a>
          <nz-switch
            *ngIf="showToggleSection"
            class="text-end"
            nzSize="small"
            [ngModel]="isSectionActive('impostazioni')"
            (ngModelChange)="
              setAccessSection('impostazioni', $event)
            "></nz-switch>
        </li>
        <div
          *ngIf="checkMonitoraggio"
          class="d-flex flex-column justify-content-between h-100">
          <!-- Contenitore sezioni monitoraggio -->
          <div>
            <li class="nav-link" *ngIf="checkMonitoraggio">
              <a
                class="hover-pointer"
                routerLink="monitoraggio"
                routerLinkActive="active-link">
                <span class="icon material-symbols-outlined">
                  <mat-icon [matTooltip]="isSidenavClosed ? 'Dashboard' : ''"
                    >dashboard</mat-icon
                  >
                </span>
                <span class="badge ps-1 text"> DASHBOARD </span>
              </a>
            </li>

            <!-- Fatturazione ore su monitoraggio -->
            <li
              class="nav-link hover-sidebar"
              *ngIf="checkMonitoraggio && canAccessSection('monitoraggio')"
              class="nav-link">
              <a
                class="hover-pointer ms-1"
                routerLink="monitoraggio/fatturazione"
                routerLinkActive="active-link">
                <span [matTooltip]="isSidenavClosed ? 'Fatturazione' : ''">
                  <img
                    src="../../../../assets/images/euro_billing.svg"
                    alt="Euro"
                    class="icon-img" />
                </span>
                <span class="text ps-1 ms-1">FATTURAZIONE</span>
              </a>
              <nz-switch
                *ngIf="showToggleSection"
                class="text-end"
                nzSize="small"
                [ngModel]="isSectionActive('monitoraggio')"
                (ngModelChange)="
                  setAccessSection('monitoraggio', $event)
                "></nz-switch>
            </li>
          </div>
          <!-- TORNA SU SVILUPPO SEMPRE ALLA FINE -->
          <li class="nav-link" *ngIf="checkMonitoraggio">
            <a
              class="hover-pointer"
              routerLink="bacheca"
              routerLinkActive="active-link">
              <span class="icon material-symbols-outlined">
                <mat-icon
                  [matTooltip]="isSidenavClosed ? 'torna su sviluppo' : ''"
                  >keyboard_backspace</mat-icon
                >
                <mat-badge
                  *ngIf="isSidenavClosed"
                  [matBadge]="notification"
                  matBadgeOverlap="false"
                  matBadgeSize="small"
                  [matBadgeHidden]="notification == 0"
                  class="badge px-0"></mat-badge>
              </span>
              <span
                [matBadge]="notification"
                matBadgeOverlap="false"
                matBadgeSize="small"
                [matBadgeHidden]="notification == 0"
                class="badge ps-1 text"
                >TORNA SU SVILUPPO</span
              >
            </a>
          </li>
        </div>
      </ul>
    </div>
    <ul class="bottom-content h-25 ps-0">
      <li *ngIf="profileData != null">
        <a
          class="hover-pointer"
          routerLink="profilo-utente"
          routerLinkActive="active-link">
          <span>
            <img [src]="path" alt="" class="rounded-circle icon profile" />
          </span>
          <span class="text ps-1 profile">{{
            profileData.first_name + ' ' + profileData.last_name
          }}</span>
        </a>
      </li>
      <li class="nav-link">
        <a class="hover-pointer" (click)="logout()">
          <span class="icon material-symbols-outlined">
            <mat-icon *ngIf="!isSidenavClosed">logout</mat-icon>
            <mat-icon *ngIf="isSidenavClosed" matTooltip="Logout"
              >logout</mat-icon
            >
          </span>
          <span class="text ps-1">LOGOUT</span>
        </a>
      </li>
    </ul>
  </div>
</nav>
